import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import TextField from "@mui/material/TextField";
import {
  getDoctorAndClinicalInformation,
  submitDoctorAndClinicalInformation,
  getDepIntDataApi,
  updateDepIntData,
  createAuditLogs,
} from "../../../api/providerApi/providerApi";
import { toast } from "react-toastify";
import useEncryption from "../../../services/useEncryption";
import path from "../../../path";
import { stepOneSchema } from "../../../services/formValidator/providerSignupValidator";
import useHeaders from "../../../helpers/useHeaders";
import { useSelector } from "react-redux";
import { selectLoc } from "../../../redux/slice/locSlice";

const validationSchema = stepOneSchema;

export const Stepone = ({ providerId }) => {
  const [initialData, setInitialData] = useState(null);
  const [fileName, setFileName] = useState("");
  const [depData, setDepData] = useState(null);
  const { encryptData, decryptData } = useEncryption();
  // const [enableField, setEnableFields] = useState(true);
  const headers = useHeaders();
  const { loc } = useSelector(selectLoc);
  const [buttonText, setButtonText] = useState("Saved");

  const fetchDoctorAndClinicalInformation = async () => {
    try {
      const response = await getDoctorAndClinicalInformation(providerId);
      const depResponse = await getDepIntDataApi(providerId);
      const decryptedData = decryptData(depResponse?.data?.data);
      setInitialData(response?.data?.data);
      setDepData(decryptedData);
    } catch ({ error }) {}
  };

  useEffect(() => {
    fetchDoctorAndClinicalInformation();
  }, [providerId]);

  useEffect(() => {
    if (initialData) {
      const imageUrl = `${path}/${initialData?.photo?.split("/").pop()}`;
      // Fetch the image from the provided URL
      fetch(imageUrl).then(async (response) => {
        // Convert the image to a Blob
        const blob = await response.blob();
        // Create a File object from the Blob
        const file = new File([blob], imageUrl.split("/").pop(), {
          type: blob.type,
        });
        // Create a DataTransfer object to simulate a file being selected
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);

        setFileName(initialData?.photo?.split("/").pop());

        setFieldValue("doctorPhoto", dataTransfer.files[0]);
      });

      formik.setValues({
        doctorName: initialData?.doctorPreferredName,
        firstName: initialData?.firstName,
        lastName: initialData?.lastName,
      });
      setButtonText("Saved");
    }
  }, [initialData, depData]);

  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  };

  useEffect(() => {}, [fileName]);
  const formik = useFormik({
    initialValues: {
      doctorName: "",
      firstName: "",
      lastName: "",
      doctorPhoto: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        let formatedData = {
          preTrainingCall: values.preTrainingCall,
          additionalDepartmentInterests: values.additionalDepartmentInterests,
        };
        const data = encryptData(formatedData);
        let depResponse = await updateDepIntData(data, providerId);

        let doctorData = {
          doctorName: values.doctorName,
          firstName: values.firstName,
          lastName: values.lastName,
          doctorPhoto: values.doctorPhoto,
        };

        const response = await submitDoctorAndClinicalInformation(
          providerId,
          doctorData
        );
        let obj = {
          event: `SuperAdmin has updated Optometrist Onboarding for loction ${loc.organization_name}`,
        };
        await createAuditLogs({ data: encryptData(obj) }, headers);
        toast.success("Information updated successfully");
        setButtonText("Saved");
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    },
  });

  const { setFieldValue, touched, errors } = formik;

  const handleFieldChange = (e) => {
    formik.handleChange(e);
    setButtonText("Save Changes");
  };

  return (
    <div className="panel-box">
      <form className="sectionalForms" onSubmit={formik.handleSubmit}>
        <br />
        <div className="row">
          <div className="subtitle">Doctor Contact</div>
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="formdesign">
              <TextField
                id="doctorName"
                name="doctorName"
                label="Doctor Name(preferred)"
                className="w-100"
                style={{ backgroundColor: "#F7F7D2" }}
                variant="outlined"
                size="small"
                multiline
                onChange={handleFieldChange}
                onBlur={formik.handleBlur}
                value={formik.values.doctorName}
                error={
                  formik.touched.doctorName && Boolean(formik.errors.doctorName)
                }
                helperText={
                  formik.touched.doctorName
                    ? formik.errors.doctorName
                    : "How would you (the doctor) like to be addressed by patients? (Ex: Dr. First Name, Dr. Last Name, etc…)"
                }
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="formdesign">
              <TextField
                id="firstName"
                name="firstName"
                label="First Name"
                className="w-100"
                style={{ backgroundColor: "#F7F7D2" }}
                variant="outlined"
                size="small"
                onChange={handleFieldChange}
                onBlur={formik.handleBlur}
                value={formik.values.firstName}
                error={
                  formik.touched.firstName && Boolean(formik.errors.firstName)
                }
                helperText={formik.touched.firstName && formik.errors.firstName}
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="formdesign">
              <TextField
                id="lastName"
                name="lastName"
                label="Last Name"
                className="w-100"
                variant="outlined"
                size="small"
                style={{ backgroundColor: "#F7F7D2" }}
                onChange={handleFieldChange}
                onBlur={formik.handleBlur}
                value={formik.values.lastName}
                error={
                  formik.touched.lastName && Boolean(formik.errors.lastName)
                }
                helperText={formik.touched.lastName && formik.errors.lastName}
              />
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12">
            {/* <div className="formdesign">
              <TextField
                id="doctorPhoto"
                name="doctorPhoto"
                label="Doctor Photo (upload)"
                className="w-100"
                variant="outlined"
                size="small"
                type="file"
                onChange={(event) => {
                  const file = event.currentTarget.files[0];
                  if (file) {
                    setFileName(file.name);
                    formik.setFieldValue("doctorPhoto", file);
                    setButtonText("Save Changes");
                  } else {
                    setFileName("");
                    formik.setFieldValue("doctorPhoto", null);
                  }
                }}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.doctorPhoto &&
                  Boolean(formik.errors.doctorPhoto)
                }
                helperText={
                  formik.touched.doctorPhoto && formik.errors.doctorPhoto
                }
                InputLabelProps={{
                  shrink: true,
                }}
              />
              {fileName && <p>{fileName}</p>}
            </div> */}

            <div className="formdesign">
              <TextField
                id="doctorPhoto"
                name="doctorPhoto"
                label="Doctor Photo (upload)"
                className="w-100"
                variant="outlined"
                size="small"
                type="file"
                onChange={(event) => {
                  const file = event.currentTarget.files[0];

                  if (file) {
                    const maxSize = 5 * 1024 * 1024; // 2MB

                    if (file.size > maxSize) {
                      toast.error("File size must be less than 5MB"); // 🚨 toast instead of inline error
                      setFileName("");
                      formik.setFieldValue("doctorPhoto", null);
                      return;
                    }

                    // ✅ valid file
                    setFileName(file.name);
                    formik.setFieldValue("doctorPhoto", file);
                    setButtonText("Save Changes");
                  } else {
                    setFileName("");
                    formik.setFieldValue("doctorPhoto", null);
                  }
                }}
                onBlur={formik.handleBlur}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              {fileName && <p>{fileName}</p>}
            </div>



          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="text-end">
              <div className="text-end modalactions">
                <button className="btn btn-blacked" type="submit">
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
